import React from 'react';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Achievements from './components/Achievements';

function App() {
  return (
    <>
      <Helmet>
        <title>SKYZM - Expert Software Development</title>
        <meta name="description" content="SKYZM builds cutting-edge software and web solutions. Custom apps, websites, and more." />
        <meta name="keywords" content="software development, web development, mobile apps, cloud, react, tailwind, professional services" />
      </Helmet>
      <div className="bg-gray-900 text-white">
        <Navbar />
        <Hero />
        <Services />
        <Achievements />
        <Contact />
        <Footer />
      </div>
    </>
  );
}

export default App;
